import { AddonFragment } from '@stigg-types/apiTypes';
import { EntityValueCell } from '@stigg-components';
import { AddonIcon } from './AddonIcon';

export const AddonValueCell = ({ addon, disabledText }: { addon: AddonFragment; disabledText?: string }) => {
  return <EntityValueCell entity={addon} disabledText={disabledText} icon={<AddonIcon addon={addon} />} />;
};
